<template>
  <div class="tw:flex tw:flex-col tw:flex-1 tw:bg-white tw:w-full tw:max-w-[160rem] tw:mx-auto" role="main">
    <div
      aria-label="registration form"
      class="tw:h-full tw:flex tw:items-center tw:justify-center tw:bg-white tw:p-4"
      role="region"
    >
      <div class="tw:sm:max-w-lg tw:md:max-w-md tw:mx-auto tw:flex tw:flex-col tw:w-full">
        <form class="tw:flex tw:flex-col tw:flex-1 tw:sm:px-0 tw:pt-16 tw:pb-32 tw:sm:pt-12 tw:md:pb-0">
          <div class="tw:mb-4 tw:sm:mb-6">
            <EdroneHeader
              :centered="true"
              :desc="translation.subtitle"
              :title="translation.title"
              mobile-type="h2"
              type="h1"
            />
          </div>

          <p v-if="googleError" class="tw:mb-2 tw:text-sm tw:text-red-500">
            {{ googleError }}
          </p>

          <GoogleSignInButton
            :translations="translation.google"
            class="tw:mb-4"
            context="register"
            @error="handleGoogleError"
            @success="handleGoogleFillForm"
          />

          <!--          <div class="tw:flex tw:justify-center tw:mb-4">-->
          <!--            <a-->
          <!--              class="tw:flex tw:items-center tw:justify-center tw:gap-2 tw:border tw:border-gray-300 tw:rounded tw:bg-white tw:text-gray-700 tw:text-sm tw:font-medium tw:no-underline hover:tw:bg-gray-50 tw:transition-colors"-->
          <!--              href="https://admin.shopify.com/apps/edrone/shopify/app/register-edrone"-->
          <!--              style="width: 278px; height: 38px"-->
          <!--            >-->
          <!--              <svg height="20" viewBox="0 0 256 292" width="20" xmlns="http://www.w3.org/2000/svg">-->
          <!--                <path-->
          <!--                  d="M223.774 57.34c-.201-1.46-1.48-2.268-2.537-2.357-1.055-.088-23.383-1.743-23.383-1.743s-15.507-15.395-17.209-17.099c-1.703-1.703-5.029-1.185-6.32-.805-.19.056-3.388 1.043-8.678 2.68-5.18-14.906-14.322-28.604-30.405-28.604-.444 0-.901.018-1.358.044C129.31 3.407 123.644 0 118.85 0c-37.54 0-55.529 46.835-61.16 70.67l-26.272 8.117c-8.078 2.532-8.355 2.78-9.412 10.39C21.093 95.73 0 256.236 0 256.236l175.876 33.03L256 266.75s-32.025-207.942-32.226-209.412v.002zM164.806 44.51a815.396 815.396 0 0 0-14.518 4.482c-.002-10.534-1.458-25.323-6.38-37.56 15.821 2.998 23.515 20.923 20.898 33.078zm-29.123 8.996c-9.859 3.049-20.656 6.385-31.422 9.713C109.874 42.135 121.123 27.318 133.69 21.893c4.661 4.29 9.983 14.538 1.993 31.613zM118.651 9.054c2.563 0 5.121.76 7.468 2.273-15.86 7.467-32.86 26.315-40.077 64.04l-24.88 7.693c6.876-23.297 23.488-74.006 57.489-74.006z"-->
          <!--                  fill="#95BF47"-->
          <!--                />-->
          <!--                <path-->
          <!--                  d="M221.237 54.983c-1.055-.088-23.383-1.743-23.383-1.743s-15.507-15.395-17.209-17.099c-.637-.634-1.496-.959-2.394-1.099l-2.374 48.674 80.123-17.356s-32.025-207.942-32.226-209.412c-.201-1.46-1.48-2.268-2.537-2.357z"-->
          <!--                  fill="#5E8E3E"-->
          <!--                  transform="translate(0 145.392)"-->
          <!--                />-->
          <!--                <path-->
          <!--                  d="M133.702 99.936l-11.063 32.866s-9.728-5.157-21.612-5.157c-17.465 0-18.348 10.947-18.348 13.713 0 15.068 39.305 20.848 39.305 56.162 0 27.78-17.623 45.665-41.396 45.665-28.515 0-43.118-17.734-43.118-17.734l7.639-25.228s15.001 12.882 27.66 12.882c8.265 0 11.652-6.502 11.652-11.254 0-19.657-32.252-20.536-32.252-52.894 0-27.218 19.553-53.576 59.004-53.576 15.233 0 22.529 4.555 22.529 4.555z"-->
          <!--                  fill="#FFF"-->
          <!--                />-->
          <!--              </svg>-->
          <!--              {{ translation.shopify.continueWith }}-->
          <!--            </a>-->
          <!--          </div>-->

          <div class="tw:flex tw:items-center tw:gap-3 tw:mb-4">
            <div class="tw:flex-1 tw:h-px tw:bg-gray-300"></div>
            <span class="tw:text-gray-500 tw:text-sm">{{ translation.google?.or || "or" }}</span>
            <div class="tw:flex-1 tw:h-px tw:bg-gray-300"></div>
          </div>

          <div class="tw:space-y-3">
            <Field v-slot="{ value, handleChange, errorMessage, handleBlur }" name="name">
              <EdroneInput
                :error-msg="errorMessage"
                :invalid="!!errorMessage"
                :label="translation.name.label"
                :placeholder="translation.name.placeholder"
                :value="value"
                autocomplete="given-name"
                name="firstName"
                @blur="() => handleBlur()"
                @input="handleChange"
              />
            </Field>

            <Field v-slot="{ value, handleChange, errorMessage, handleBlur }" name="email">
              <EdroneInput
                :error-msg="formValidationErrorsBackend.email || errorMessage"
                :invalid="!!formValidationErrorsBackend.email || !!errorMessage"
                :label="translation.email.label"
                :placeholder="translation.email.placeholder"
                :value="value"
                autocomplete="email"
                name="email"
                @blur="
                  () => {
                    handleBlur();
                    setShopUrlByEmail(value);
                  }
                "
                @input="
                  (val) => {
                    handleChange(val);
                    clearBackendError('email');
                  }
                "
              />
            </Field>

            <Field v-slot="{ value, handleChange, errorMessage, handleBlur }" name="phoneNumber">
              <EdroneInput
                :error-msg="errorMessage"
                :invalid="!!errorMessage"
                :label="translation.phone.label"
                :placeholder="translation.phone.placeholder"
                :value="value"
                autocomplete="tel"
                name="phoneNumber"
                @blur="() => handleBlur()"
                @input="handleChange"
              />
            </Field>

            <Field v-slot="{ value, handleChange, errorMessage, handleBlur }" name="shopUrl">
              <EdroneInput
                :error-msg="formValidationErrorsBackend.shopUrl || errorMessage"
                :invalid="!!formValidationErrorsBackend.shopUrl || !!errorMessage"
                :label="translation.url.label"
                :placeholder="translation.url.placeholder"
                :value="value"
                autocomplete="url"
                name="shopUrl"
                @blur="
                  () => {
                    ensureHttpsPrefix(value);
                    handleBlur();
                  }
                "
                @input="
                  (val) => {
                    handleChange(val);
                    clearBackendError('shopUrl');
                  }
                "
              />
            </Field>

            <RegistrationCodeInput :initial-code="initialRegistrationCode" />
          </div>

          <div class="tw:hidden tw:md:flex tw:mt-10">
            <EdroneButton
              :disabled="!isFormValidForSubmit"
              :loading="isLoading"
              class="tw:w-full tw:h-full"
              unique-id="RegisterForm_submit-button"
              @click="handleFormSubmit"
            >
              {{ translation.submit }}
            </EdroneButton>
          </div>
          <p class="tw:hidden tw:md:block tw:text-center tw:text-xs tw:text-default-600 tw:mt-2">
            *{{ trans._register.platforms.noCardRequired }}
          </p>

          <p
            v-if="formValidationErrorsBackend.captcha"
            class="tw:hidden tw:md:flex tw:md:justify-center tw:caption tw:text-red-500 tw:mt-2"
          >
            {{ translation.notification.error.register }}
          </p>

          <p class="tw:body-2 tw:mt-6 tw:text-center" v-html="agreementsText"></p>
        </form>

        <div
          class="tw:fixed tw:bottom-0 tw:left-0 tw:right-0 tw:bg-white tw:border-t tw:border-default-200 tw:p-4 tw:z-20 tw:shadow-lg tw:md:hidden"
        >
          <div class="tw:max-w-xs tw:sm:max-w-xl tw:mx-auto tw:flex tw:flex-col tw:gap-2">
            <EdroneButton
              :disabled="!isFormValidForSubmit"
              :loading="isLoading"
              class="tw:w-full"
              unique-id="RegisterForm_submit-button-mobile"
              @click="handleFormSubmit"
            >
              {{ translation.submit }}
            </EdroneButton>
            <p class="tw:text-sm tw:text-center tw:mt-3">
              {{ trans._register.platforms.haveAccount }}
              {{ " " }}
              <a class="tw:text-blue-500 tw:no-underline" href="/login">
                {{ trans._register.platforms.login }}
              </a>
            </p>
          </div>
          <p v-if="formValidationErrorsBackend.captcha" class="tw:caption tw:text-red-500 tw:text-center tw:mt-2">
            {{ translation.notification.error.register }}
          </p>
        </div>
      </div>
    </div>
  </div>
</template>

<script lang="ts" setup>
import axios from "axios";
import { ref, onMounted, computed, nextTick } from "vue";
import { storeToRefs } from "pinia";
import { useRegisterStore } from "vue-app-new/modules/Register/store/Register.store";
import { splitAtFirstSpace } from "./RegisterForm.helpers";
import { amplitudeSendEvent } from "vue-app/utils/amplitude";
import { useRestrictedDomains } from "./composables/useRestrictedDomains/useRestrictedDomains.composable";
import { Field, useForm } from "vee-validate";
import { toTypedSchema } from "@vee-validate/zod";
import { RegisterFormSchema, RegisterFormDefaultValues, RegisterFormModel } from "./RegisterForm.model";
import EdroneButton from "vue-app/edroneComponents/EdroneButton.vue";
import EdroneInput from "vue-app/edroneComponents/EdroneInput.vue";
import EdroneHeader from "edrone-components/EdroneHeader.vue";
import RegistrationCodeInput from "./components/RegistrationCodeInput/RegistrationCodeInput.vue";
import { DTOTrackerProduct } from "vue-app/api/dto";
import { useCaptcha } from "vue-app/composables/useCaptcha";
import { type GoogleUserData } from "vue-app/composables/useGoogleSignIn/useGoogleSignIn.composable";
import GoogleSignInButton from "vue-app/components/Account/GoogleSignInButton/GoogleSignInButton.vue";

const { restrictedDomains } = useRestrictedDomains();

const translation = window._trans._register.form;
const urlParams = new URL(location.href).searchParams;

const store = useRegisterStore();
const { formValidationErrorsBackend, hasRegistrationCode, registrationCode } = storeToRefs(store);

const initialRegistrationCode = urlParams.get("code") || undefined;

const googleError = ref<string>("");
const googleUserData = ref<GoogleUserData | null>(null);

onMounted(() => {
  window.scrollTo(0, 0);
});

function handleGoogleError(errorMessage: string) {
  googleError.value = errorMessage;
}

function handleGoogleFillForm(userData: GoogleUserData) {
  googleError.value = "";

  const fullName = `${userData.firstName} ${userData.lastName}`.trim();
  setFieldValue("name", fullName);
  setFieldValue("email", userData.email);

  const emailDomain = userData.email.split("@")[1];
  if (emailDomain && emailDomain !== "gmail.com") {
    setFieldValue("shopUrl", `https://${emailDomain}`);
  }

  googleUserData.value = userData;

  nextTick(() => {
    const phoneInput = document.querySelector('input[name="phoneNumber"]') as HTMLInputElement;
    if (phoneInput) {
      phoneInput.focus();
    }
  });
}

const getInitialValuesFromUrl = (): Partial<RegisterFormModel> => {
  const initialValues: Partial<RegisterFormModel> = {};

  const nameParam = urlParams.get("name");
  if (nameParam) {
    initialValues.name = nameParam;
  }

  const emailParam = urlParams.get("email");
  if (emailParam) {
    initialValues.email = emailParam;
  }

  const phoneNumberParam = urlParams.get("phoneNumber") || urlParams.get("phone");
  if (phoneNumberParam) {
    initialValues.phoneNumber = phoneNumberParam;
  }

  const shopUrlParam = urlParams.get("shopUrl") || urlParams.get("url");
  if (shopUrlParam) {
    initialValues.shopUrl =
      shopUrlParam.startsWith("http://") || shopUrlParam.startsWith("https://")
        ? shopUrlParam
        : `https://${shopUrlParam}`;
  }

  return initialValues;
};

const { handleSubmit, values, meta, setFieldValue } = useForm<RegisterFormModel>({
  validationSchema: toTypedSchema(RegisterFormSchema),
  initialValues: {
    ...RegisterFormDefaultValues,
    ...getInitialValuesFromUrl(),
  },
});

const isLoading = ref<boolean>(false);

const isFormValidForSubmit = computed(() => {
  return (
    meta.value.valid &&
    !formValidationErrorsBackend.value.email &&
    !formValidationErrorsBackend.value.shopUrl &&
    !formValidationErrorsBackend.value.captcha
  );
});

const setShopUrlByEmail = (emailValue: string) => {
  const userDomain = emailValue.split("@")[1];
  if (userDomain && !values.shopUrl && restrictedDomains.value && !restrictedDomains.value.includes(userDomain)) {
    setFieldValue("shopUrl", `https://${userDomain}`);
  }
};

const ensureHttpsPrefix = (urlValue: string) => {
  if (urlValue && !urlValue.startsWith("http://") && !urlValue.startsWith("https://")) {
    setFieldValue("shopUrl", `https://${urlValue}`);
  }
};

const clearBackendError = (field: "email" | "shopUrl") => {
  formValidationErrorsBackend.value[field] = "";
};

const agreementsText = translation.agreements.text
  .replace(
    /\{Terms of Service\}/g,
    `<a href="${translation.agreements.links.termsOfService}" target="_blank" class="tw:text-blue-500">${translation.agreements.termsOfService}</a>`
  )
  .replace(
    /\{Privacy Policy\}/g,
    `<a href="${translation.agreements.links.privacyPolicy}" target="_blank" class="tw:text-blue-500">${translation.agreements.privacyPolicy}</a>`
  );

const handleFormSubmit = handleSubmit(
  async () => {
    const { executeRecaptcha } = useCaptcha();
    const token = await executeRecaptcha("REGISTER");
    if (token) {
      await register(token);
    }
  },
  ({ errors }) => {
    amplitudeSendEvent("register_form_validation_failed", {
      step: "form",
      name_error: errors.name || "",
      email_error: errors.email || "",
      phone_error: errors.phoneNumber || "",
      url_error: errors.shopUrl || "",
      captcha_error: "",
    });
  }
);

async function register(token: string) {
  isLoading.value = true;

  amplitudeSendEvent("register_api_request_start", {
    step: "form",
    is_google_registration: !!googleUserData.value,
  });

  try {
    axios.get<DTOTrackerProduct[]>("/products/scrapped", {
      params: { url: values.shopUrl },
    });
    const { data } = await axios.post("/register", {
      first_name: splitAtFirstSpace(values.name)[0],
      last_name: splitAtFirstSpace(values.name)[1] || "",
      email: values.email,
      subscribe: true,
      phone: values.phoneNumber,
      url: values.shopUrl,
      registration_code: hasRegistrationCode.value ? registrationCode.value : null,
      onboarding_id: "",
      g_recaptcha_response: token,
      lang: urlParams.get("lang"),
      confirmed: urlParams.get("confirmed"),
      google_id: googleUserData.value?.googleId || null,
    });

    if (data.status === "success") {
      amplitudeSendEvent("register_success", {
        email_domain: values.email.split("@")[1],
        has_referral_code: !!urlParams.get("code"),
        language: urlParams.get("lang") || "en",
        is_google_registration: !!googleUserData.value,
      });
      window.location.href = "/login/trackers";
    } else {
      let errorType = "unknown";
      let errorMessage = "";

      if (data.error._email === "Email already exists") {
        errorType = "email_exists";
        errorMessage = translation.validation.backend.emailExists;
        formValidationErrorsBackend.value.email = translation.validation.backend.emailExists;
      }

      if (data.error._email === "Email is invalid") {
        errorType = "email_invalid";
        errorMessage = translation.validation.backend.emailIsInvalid;
        formValidationErrorsBackend.value.email = translation.validation.backend.emailIsInvalid;
      }

      if (data.error._captcha === "Captcha not valid") {
        errorType = "captcha_invalid";
        errorMessage = translation.validation.backend.captchaInvalid;
        formValidationErrorsBackend.value.captcha = translation.validation.backend.captchaInvalid;
      }

      amplitudeSendEvent("register_form_api_error", {
        error_type: errorType,
        error_message: errorMessage,
        step: "form",
      });
    }
  } catch (error) {
    amplitudeSendEvent("register_form_api_error", {
      error_type: "network_error",
      error_message: "Network error or server error",
      step: "form",
    });
  } finally {
    isLoading.value = false;
  }
}
</script>

<style>
@supports (-webkit-touch-callout: none) {
  @media screen and (max-device-width: 812px) and (orientation: portrait) {
    input,
    select,
    textarea {
      font-size: 16px !important;
    }
  }
}
</style>
